import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed, PropType,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'UiParagraph',
  props: {
  type: {
    type: String as PropType<'p' | 'span'>,
    default: 'p',
  },
  color: {
    type: String as PropType<'gray' | 'white' | 'primary'>,
    default: 'gray',
  },
  size: {
    type: String as PropType<'base' | 'lg' | 'xl' | '2xl'>,
    default: 'base',
  },
  align: {
    type: String as PropType<'left' | 'center' | 'right'>,
    default: 'center',
  },
  animation: {
    type: String as PropType<'fadeIn' | 'slideDown' | 'slideUp' | 'slideLeft' | 'slideRight'>,
    default: 'fadeIn',
  },
},
  setup(__props) {



// Props
const props = __props;

// Data
const colorClasses = {
  gray: 'text-gray-500 dark:text-white',
  white: 'text-white',
  primary: 'text-primary',
};

const sizeClasses = {
  base: 'text-base',
  lg: 'text-lg sm:text-xl/8',
  xl: 'text-xl sm:text-2xl',
  '2xl': 'text-2xl sm:text-3xl',
};

const alignClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

const animationClasses = {
  fadeIn: 'animate-fade-in',
  slideDown: 'animate-slide-down',
  slideUp: 'animate-slide-up',
  slideLeft: 'animate-slide-left',
  slideRight: 'animate-slide-right',
};

// Merge all class sources
const computedClasses = computed(() => [
  'text-pretty',
  colorClasses[props.color],
  sizeClasses[props.size],
  alignClasses[props.align],
  animationClasses[props.animation],
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([...computedClasses.value, _ctx.$attrs.class].filter(Boolean))
  }, [
    _createElementVNode("p", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})